import React, { Component } from 'react'

import { PhoneSystemForm } from '../PhoneSystemForm'
import HeadingBanner from 'components/Text/HeadingBanner'
import cn from 'classnames'

import sText from 'components/Text/Text.scss'

export default class PhoneSystemFormModal extends Component {
  state = {
    headings: {
      heading: 'Create Phone System',
      subHeading: '',
    },
  }

  setHeadings = headings => {
    this.setState({ headings })
  }

  render() {
    const { productName, modalConfirm } = this.props

    const {
      headings: { heading, subHeading },
    } = this.state

    return (
      <div>
        <HeadingBanner filled>
          <h3 className={cn(sText.heading3, sText.accent)}>{heading}</h3>
          <div className={sText.descrip2}>{subHeading}</div>
        </HeadingBanner>

        <PhoneSystemForm
          productName={productName}
          onAfterSubmit={modalConfirm}
          setHeadings={this.setHeadings}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PhoneSystem/PhoneSystemFormModal/PhoneSystemFormModal.jsx